

















































































































































































































































































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Prop, Vue } from "vue-property-decorator";
import { appModule } from "@/store/modules/app";
import { storeSerahTerimaOperasi } from "@/store/modules/SerahTerimaOperasiStore";
import SerahTerimaOperasiSvc from "@/services/SerahTerimaOperasi";
import ChecklistYTV from "./ChecklistYTV.vue";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import { userModule } from "@/store/modules/user";
import { alasanTtdMengunciHapus, slotTandaTanganDokumen, SlotTtd } from "@/utils/hapusSetelahTtd";

@Component({
  components: {
    ChecklistYTV,
    CardModalTtd
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardSerahTerimaOperasi extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  get canCreate(): boolean {
    if (this.readOnly) return false;
    return userModule.canAccessForm("serah_terima_kamar_operasi", "create");
  }

  step = 1;
  isCreating = false;
  editingId: number | null = null;
  saving = false;
  deleting = false;
  prefilling = false;
  prefillMeta: any = null;

  menuPraTanggal = false;
  menuPascaTanggal = false;

  // Sign
  signDialog = false;
  signRecord: any = null;
  modalTtd = false;
  signRole = "";
  signTargetId: number | null = null;

  // Form data
  form: any = this.getEmptyForm();

  // Checklist arrays (local state, synced to form on save)
  praVisiteItems: any[] = [];
  praPenunjangItems: any[] = [];
  praTransfusiItems: any[] = [];
  praAdministrasiItems: any[] = [];
  praPersiapanItems: any[] = [];
  pascaAdminItems: any[] = [];
  pascaMaterialItems: any[] = [];

  mounted() {
    storeSerahTerimaOperasi.fetchByRegister(this.register);
    this.initChecklists();
  }

  get loading() {
    return storeSerahTerimaOperasi.loading;
  }

  get stateItems() {
    return storeSerahTerimaOperasi.items;
  }

  get isPraLocked() {
    if (!this.editingId) return false;
    const item = this.stateItems.find(i => i.id === this.editingId);
    return item?.is_pra_fully_signed || false;
  }

  get isPascaLocked() {
    if (!this.editingId) return false;
    const item = this.stateItems.find(i => i.id === this.editingId);
    return item?.is_pasca_fully_signed || false;
  }

  getEmptyForm() {
    return {
      pra_tanggal: localISODate(),
      pra_pukul: "",
      pra_radiologi_lainnya: "",
      pra_persediaan_darah_detail: "",
      pra_profilaksis_antibiotik_detail: "",
      pasca_tanggal: "",
      pasca_pukul: "",
      pasca_tujuan: null
    };
  }

  initChecklists() {
    this.praVisiteItems = [
      { key: "visite_dokter_bedah", label: "Visite dokter bedah / Asesmen pra bedah", y: false, t: false, v: false },
      { key: "visite_dokter_anestesi", label: "Visite dokter anestesi / Asesmen pra anestesi", y: false, t: false, v: false },
      { key: "ic_anestesi_edukasi_nyeri", label: "Informed consent anestesi dan Edukasi manajemen nyeri", y: false, t: false, v: false },
      { key: "asesmen_risiko_jatuh", label: "Asesmen Risiko Jatuh", y: false, t: false, v: false },
    ];

    this.praPenunjangItems = [
      { key: "lab_darah_lengkap", label: "Laboratorium (darah lengkap)", y: false, t: false, v: false },
      { key: "lab_kimia_darah", label: "Laboratorium (kimia darah)", y: false, t: false, v: false },
      { key: "ekg", label: "EKG", y: false, t: false, v: false },
      { key: "radiologi_thorax", label: "Radiologi — Thorax", y: false, t: false, v: false },
      { key: "radiologi_usg", label: "Radiologi — USG", y: false, t: false, v: false },
      { key: "radiologi_abdomen", label: "Radiologi — Abdomen", y: false, t: false, v: false },
      { key: "radiologi_lainnya", label: "Radiologi — Lainnya", y: false, t: false, v: false },
    ];

    this.praTransfusiItems = [
      { key: "ic_transfusi_darah", label: "Informed consent transfusi darah", y: false, t: false, v: false },
      { key: "persediaan_transfusi_darah", label: "Persediaan transfusi darah", y: false, t: false, v: false },
    ];

    this.praAdministrasiItems = [
      { key: "administrasi_pra_operasi", label: "Administrasi pra operasi terlampir", y: false, t: false, v: false },
    ];

    this.praPersiapanItems = [
      { key: "protese_gigi_palsu", label: "Protese / gigi palsu (dilepas)", y: false, t: false, v: false },
      { key: "puasa", label: "Puasa", y: false, t: false, v: false },
      { key: "perhiasan_kacamata", label: "Perhiasan / kaca mata (dilepas)", y: false, t: false, v: false },
      { key: "tidak_makeup", label: "Tidak memakai make up", y: false, t: false, v: false },
      { key: "profilaksis_antibiotik", label: "Profilaksis Antibiotik", y: false, t: false, v: false },
      { key: "lavemen", label: "Lavemen", y: false, t: false, v: false },
      { key: "dower_catheter", label: "Dower Catheter", y: false, t: false, v: false },
      { key: "iv_line", label: "IV Line", y: false, t: false, v: false },
      { key: "ngt", label: "NGT", y: false, t: false, v: false },
      { key: "traksi", label: "Traksi", y: false, t: false, v: false },
      { key: "site_marking", label: "Site Marking", y: false, t: false, v: false },
    ];

    this.pascaAdminItems = [
      { key: "laporan_operasi", label: "Laporan Operasi", y: false, t: false, v: false },
      { key: "laporan_anestesi", label: "Laporan pantauan anestesi", y: false, t: false, v: false },
      { key: "laporan_obat_implant", label: "Laporan pemakaian obat / implant", y: false, t: false, v: false },
      { key: "form_lab_pa_kultur", label: "Form permintaan Lab / PA / Kultur", y: false, t: false, v: false },
      { key: "form_rontgen", label: "Form permintaan Rontgen", y: false, t: false, v: false },
    ];

    this.pascaMaterialItems = [
      { key: "material_dibawakan", label: "Material yang dibawakan", y: false, t: false, v: false },
      { key: "material_lab", label: "Material pemeriksaan Lab", y: false, t: false, v: false },
      { key: "obat_dibawakan", label: "Obat yang dibawakan", y: false, t: false, v: false },
    ];
  }

  getItemY(items: any[], key: string): boolean {
    const item = items.find(i => i.key === key);
    return item?.y || false;
  }

  async startCreate() {
    this.isCreating = true;
    this.editingId = null;
    this.step = 1;
    this.form = this.getEmptyForm();
    this.initChecklists();
    this.prefillMeta = null;
    await this.loadPrefill(false);
  }

  // Tarik data redundan dari Pengantar Transfer Internal pada register ini.
  // Non-destruktif: hanya men-set checklist y=true yang dipetakan + tanggal/jam.
  async loadPrefill(isManual: boolean) {
    if (this.isPraLocked) return;
    this.prefilling = true;
    try {
      const resp = await SerahTerimaOperasiSvc.prefill(this.register);
      const body = resp?.data;
      if (body?.status == "1" && body.data) {
        this.applyPrefill(body.data);
        this.prefillMeta = body.meta || null;
        if (isManual) appModule.NoticeDelay("Data ditarik dari Pengantar Transfer Internal");
      } else if (isManual) {
        appModule.NoticeDelay("Tidak ada Pengantar Transfer Internal pada register ini");
      }
    } catch {
      // error handled by service
    } finally {
      this.prefilling = false;
    }
  }

  tarikDariTransferInternal() {
    this.loadPrefill(true);
  }

  applyPrefill(data: any) {
    if (!data) return;
    if (data.pra_tanggal) this.form.pra_tanggal = data.pra_tanggal;
    if (data.pra_pukul) this.form.pra_pukul = data.pra_pukul;

    const setY = (items: any[], map: Record<string, boolean> | null) => {
      if (!map) return;
      Object.keys(map).forEach(key => {
        const it = items.find(i => i.key === key);
        if (it && map[key]) it.y = true;
      });
    };
    setY(this.praPenunjangItems, data.pra_pemeriksaan_penunjang);
    setY(this.praAdministrasiItems, data.pra_administrasi);
  }

  formatWaktu(val: string): string {
    if (!val) return "";
    return val.toString().substring(0, 16).replace("T", " ");
  }

  startEdit(item: any) {
    this.editingId = item.id;
    this.isCreating = false;
    this.step = 1;

    this.form = {
      pra_tanggal: item.pra_tanggal || "",
      pra_pukul: item.pra_pukul ? item.pra_pukul.substring(0, 5) : "",
      pra_radiologi_lainnya: item.pra_radiologi_lainnya || "",
      pra_persediaan_darah_detail: item.pra_persediaan_darah_detail || "",
      pra_profilaksis_antibiotik_detail: item.pra_profilaksis_antibiotik_detail || "",
      pasca_tanggal: item.pasca_tanggal || "",
      pasca_pukul: item.pasca_pukul ? item.pasca_pukul.substring(0, 5) : "",
      pasca_tujuan: item.pasca_tujuan || null
    };

    this.loadChecklistFromData("praVisiteItems", item.pra_visite_asesmen);
    this.loadChecklistFromData("praPenunjangItems", item.pra_pemeriksaan_penunjang);
    this.loadChecklistFromData("praTransfusiItems", item.pra_transfusi_darah);
    this.loadChecklistFromData("praAdministrasiItems", item.pra_administrasi);
    this.loadChecklistFromData("praPersiapanItems", item.pra_persiapan_pasien);
    this.loadChecklistFromData("pascaAdminItems", item.pasca_administrasi);
    this.loadChecklistFromData("pascaMaterialItems", item.pasca_material_obat);
  }

  loadChecklistFromData(localProp: string, serverData: any[] | null) {
    if (!serverData) return;
    const localArr = this[localProp] as any[];
    for (const sd of serverData) {
      const match = localArr.find(l => l.key === sd.key);
      if (match) {
        match.y = sd.y || false;
        match.t = sd.t || false;
        match.v = sd.v || false;
      }
    }
  }

  cancelForm() {
    this.isCreating = false;
    this.editingId = null;
    this.prefillMeta = null;
    this.form = this.getEmptyForm();
    this.initChecklists();
  }

  buildPayload() {
    const toChecklist = (items: any[]) =>
      items.map(i => ({ key: i.key, y: !!i.y, t: !!i.t, v: !!i.v }));

    return {
      register_id: this.register,
      pasien_rm: this.rm,
      // Fase 1
      pra_tanggal: this.form.pra_tanggal || null,
      pra_pukul: this.form.pra_pukul || null,
      pra_visite_asesmen: toChecklist(this.praVisiteItems),
      pra_pemeriksaan_penunjang: toChecklist(this.praPenunjangItems),
      pra_radiologi_lainnya: this.form.pra_radiologi_lainnya || null,
      pra_transfusi_darah: toChecklist(this.praTransfusiItems),
      pra_persediaan_darah_detail: this.form.pra_persediaan_darah_detail || null,
      pra_administrasi: toChecklist(this.praAdministrasiItems),
      pra_persiapan_pasien: toChecklist(this.praPersiapanItems),
      pra_profilaksis_antibiotik_detail: this.form.pra_profilaksis_antibiotik_detail || null,
      // Fase 2
      pasca_tanggal: this.form.pasca_tanggal || null,
      pasca_pukul: this.form.pasca_pukul || null,
      pasca_administrasi: toChecklist(this.pascaAdminItems),
      pasca_material_obat: toChecklist(this.pascaMaterialItems),
      pasca_tujuan: this.form.pasca_tujuan || null
    };
  }

  async simpan() {
    this.saving = true;
    try {
      const payload = this.buildPayload();
      let resp;
      if (this.editingId) {
        resp = await SerahTerimaOperasiSvc.update(this.editingId, payload);
      } else {
        resp = await SerahTerimaOperasiSvc.create(payload);
      }
      if (resp.data.status == "1") {
        const skipped: string[] = resp.data.meta?.skipped_phases || [];
        if (skipped.length > 0) {
          const label: Record<string, string> = {
            pra: "Pra-Op",
            pasca: "Pasca-Op"
          };
          const fase = skipped.map(s => label[s] || s).join(" & ");
          appModule.sendErrorAlert(
            `Perubahan fase ${fase} TIDAK disimpan karena sudah ditandatangani lengkap.`
          );
        } else {
          appModule.NoticeDelay("Data berhasil disimpan");
        }
        this.cancelForm();
        storeSerahTerimaOperasi.fetchByRegister(this.register);
      }
    } catch {
      // error handled by service
    } finally {
      this.saving = false;
    }
  }

  bisaHapus(item: any): boolean {
    if (this.readOnly) return false;
    const slot: SlotTtd[] = [];
    ["pra", "pasca"].forEach(fase => {
      ["penyerah", "penerima"].forEach(peran => {
        slot.push(...slotTandaTanganDokumen(item[fase + "_signed_" + peran], item["signature_" + fase + "_" + peran]));
      });
    });
    return !alasanTtdMengunciHapus(item.creator_user_id, slot, userModule.user?.id);
  }

  async removeItem(item: any) {
    if (!this.bisaHapus(item)) return;
    const q = confirm("Anda yakin akan menghapus data serah terima ini?");
    if (!q || this.deleting) return;

    this.deleting = true;
    try {
      const resp = await SerahTerimaOperasiSvc.destroy(item.id);
      if (resp?.status == 1) {
        appModule.NoticeDelay(resp.message);
        storeSerahTerimaOperasi.fetchByRegister(this.register);
      }
    } catch {
      // handled by service
    } finally {
      this.deleting = false;
    }
  }

  cetakPdf(id: number) {
    SerahTerimaOperasiSvc.print(id);
  }

  // ======== SIGN METHODS ========

  openSignDialog(item: any) {
    this.signRecord = item;
    this.signDialog = true;
  }

  doSign(role: string) {
    this.signRole = role;
    this.signTargetId = this.signRecord.id;
    this.signDialog = false;
    this.modalTtd = true;
  }

  async passTtd(password: string) {
    if (!this.signTargetId || !this.signRole) return;

    const signFns: Record<string, Function> = {
      pra_penyerah: SerahTerimaOperasiSvc.signPraPenyerah,
      pra_penerima: SerahTerimaOperasiSvc.signPraPenerima,
      pasca_penyerah: SerahTerimaOperasiSvc.signPascaPenyerah,
      pasca_penerima: SerahTerimaOperasiSvc.signPascaPenerima
    };

    const signFn = signFns[this.signRole];
    if (!signFn) return;

    try {
      const resp = await signFn(this.signTargetId, { password });
      if (resp.data.status == "1") {
        this.modalTtd = false;
        appModule.NoticeDelay("Berhasil Tanda Tangan");
        storeSerahTerimaOperasi.fetchByRegister(this.register);
      } else {
        appModule.addMsgTtd(resp.data.message);
      }
    } catch {
      // handled by service
    }
  }

  hasPascaData(item: any): boolean {
    return !!(item.pasca_tanggal || item.pasca_tujuan || item.pasca_pukul);
  }

  tujuanLabel(val: string | null) {
    if (!val) return "-";
    const map: Record<string, string> = {
      icu_hcu: "ICU/HCU",
      ruang_rawat: "Ruang Rawat",
      pulang: "Pulang"
    };
    return map[val] || val;
  }
}
